<template lang="">
    <div class="max-w-[600px] p-8 flex justify-center items-center rounded-2xl bg-gray-100">
        <div class="h-full w-full flex justify-center items-center rounded-2xl sm:flex-col gap-4">
            <div class="flex-grow relative xl:max-w-[35%]">
                <div class="outer w-[120px] h-[120px] rounded-[50%] p-5 bg-[#79FF9D]">
                    <div class="inner h-[80px] w-[80px] rounded-[50%] flex justify-center items-center bg-white">
                        <div id="number" class="font-semibold text-primary text-[20px]">
                            {{ progressValue }}%
                        </div>
                    </div>
                </div>
                <svg class="absolute top-0 left-0" xmlns="http://www.w3.org/2000/svg" version="1.1" width="160px" height="160px">
                    <defs>
                        <linearGradient id="GradientColor">
                            <stop offset="0%" stop-color="#e91e63"/>
                            <stop offset="100%" stop-color="#673ab7"/>
                        </linearGradient>
                    </defs>
                    <circle class="progress-bar fill-[none] stroke-[#0771c5] stroke-[20px]" cx="60px" cy="60px" r="50" stroke-linecap="round" :stroke-dashoffset="progressCssValue"/>
                </svg>
            </div>
            <div class="pl-[16px] xl:max-w-[40%] text-primary">
                <h1 class="font-bold">Meta de equipe</h1>
                <p class="text-sm mt-2">
                    <strong>META</strong>:
                    {{ teamPerformance?.total }}
                </p>
                <p class="text-sm">
                    <strong>REALIZADO</strong>:
                    {{ teamPerformance?.achieved }}
                </p>
                <p v-if="individualPerformance" class="text-sm">
                    <strong>MEU RESULTADO</strong>:
                    {{ individualPerformance?.achieved }}
                </p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'RadialTeamPerformanceGoal',
    props: {
        teamPerformance: Object,
        individualPerformance: Object
    },
    computed: {
        progressValue() {
            return this.getPercent(this.teamPerformance?.achieved);
        },
        progressCssValue() {
            if(this.progressValue >= 100) {
                return 0;
            }

            return 320 - (this.progressValue * 3.2);
        },
    },
    methods: {
        getPercent(progress) {
            if (!this.teamPerformance?.total) return 0;
            const total = this.teamPerformance?.total || 100;
            const partial = progress || 0;
            return Math.round((100 * partial) / total);
        },
    }
}
</script>
<style scoped>
    .progress-bar {
        stroke-dasharray: 320;
        animation: anim 2s linear forwards;
    }
</style>
